import { render, staticRenderFns } from "./GenericMasonry.vue?vue&type=template&id=2a4d8700&scoped=true"
import script from "./GenericMasonry.vue?vue&type=script&lang=js"
export * from "./GenericMasonry.vue?vue&type=script&lang=js"
import style0 from "./GenericMasonry.vue?vue&type=style&index=0&id=2a4d8700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d8700",
  null
  
)

export default component.exports